import React from 'react';
import { useTranslation } from 'react-i18next';
import Menu from 'components/UI/Antd/Menu/Menu';

import {
  Wrapper,
  Column,
  Title
} from './FooterMenu.style.js';

const FooterMenu = ({ menu, onLinkClick }) => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      {menu.map((column, index) => {
        const { title, items } = column;
        return (
          <Column key={ index }>
            <Title>{t(title)}</Title>
            <Menu>
              {items.map((item, index) => {
                const { label, to, amplitude } = item;
                return (
                  <Menu.Item key={ index }>
                    <a href={to || '#'} onClick={ () => onLinkClick(amplitude) } target='_blank'>
                      {t(label)}
                    </a>
                  </Menu.Item>
                )
              })}
            </Menu>
          </Column>
        )
      })}
    </Wrapper>
  )
};

export default FooterMenu;
